import React from "react";
import { Navigate } from "react-router";

import ConsumerDashboard from "pages/Consumer/Dashboard";
import PermanentConnection from "pages/Consumer/ApplicationType/PermanentConnection";
import TemporaryConnection from "pages/Consumer/ApplicationType/TemporaryConnection";
import ApplicationRequestList from "pages/Consumer/ApplicationRequestList";
import NameTransfer from "pages/Consumer/ApplicationType/NameTransferConnection";
import DemandReduction from "pages/Consumer/ApplicationType/DemandReduction";
import DemandExtension from "pages/Consumer/ApplicationType/DemandExtension";
import PremiseAmalgamation from "pages/Consumer/ApplicationType/PremiseAmalgamation";
import PremiseRemoval from "pages/Consumer/ApplicationType/PremiseRemoval";
import ShiftingOfService from "pages/Consumer/ApplicationType/ShiftingOfService";
import ChangeOfCategory from "pages/Consumer/ApplicationType/ChangeOfCategory";
import NetMetering from "pages/Consumer/ApplicationType/NetMeteringConnection";
import BackupPower from "pages/Consumer/ApplicationType/BackupPower";
import RemovalOfConnection from "pages/Consumer/ApplicationType/RemovalOfConnection";
import PaymentResponse from "pages/Consumer/PaymentResponse";
import Dashboard from "pages/Dashboard";
import PowerApplicationRequest from "pages/Admin/PowerApplicationRequest";
import OtherApplicationRequest from "pages/Admin/OtherApplicationRequest";
import Complaint from "pages/Complaint";
import User from "pages/Admin/User";
import { Home } from "pages/Home";
import ProfileDetails from "pages/Profile";
import ConsumerBillDetails from "pages/Admin/ConsumerBillDetails";
import MyBills from "pages/Consumer/MyBills";
import MasterData from "pages/Admin/MasterData";
import PaymentHistory from "pages/PaymentHistory";
import BillingCycle from "pages/Admin/BillingCycle";
import BillMeterReading from "pages/Admin/BillMeterReading";
import UtilityConsumers from "pages/UtilityConsumers";
import Reports from "pages/Admin/Reports";
import BillCalculationReport from "pages/Admin/BillCalculationReport";
import SecurityDeposit from "pages/Admin/SecurityDeposit";
import UnpaidBills from "pages/Admin/UnpaidBills";
import Documents from "pages/Admin/UserDocuments";
import BillingBackupPower from "pages/Admin/BackUpPower";
import DispatchedBill from "pages/Admin/DispatchedBill";
import MakePayment from "Components/PaymentRequest/MakePayment";
import HomePageContent from "pages/Admin/HomePageContent";
import HomePageDocument from "pages/Admin/HomePageDocument";
import TemporaryDisconnectedConsumers from "pages/Admin/TemporaryDisconnectedConsumers";
import OtherUtilityPermanentConnection from "pages/Consumer/OtherApplications/PermanentConnection/index";
import OtherUtilityTemporaryConnection from "pages/Consumer/OtherApplications/TemporaryConnection/index";
import OtherApplicationNameTransfer from "pages/Consumer/OtherApplications/NameChangeTransfer/index";
import OtherUtilityDemandExtension from "pages/Consumer/OtherApplications/DemandExtension/index";
import OtherUtilityDemandReduction from "pages/Consumer/OtherApplications/DemandReduction/index";
import PowerAbstract from "pages/Admin/PowerAbstract";
import GiftInfo from "pages/Home/GiftInfo";
import OtherApplicationRequestList from "pages/Consumer/OtherApplicationRequestList";
import OutstandingInvoice from "pages/Admin/OutstandingInvoice";
import WaysToSaveMoney from "pages/Home/WaysToSaveMoney";
import EnergyCalculator from "pages/Home/EnergyCalculator";
import ErrorActivities from "pages/Admin/ErrorActivities";
import OfflinePayment from "pages/Admin/OfflinePayment";
import UserBills from "pages/Admin/UserBills";
import OtherUtilityBillMeterReading from "pages/Admin/OtherUtilityBillMeterReading";
import DailyMeterReadingReport from "pages/Admin/DailyMeterReadingReport";
import PowerOutstandingNotice from "pages/Admin/PowerOutstandingNotice";
import OutstandingReport from "pages/Admin/OutstandingReport";
import QuickPayment from "pages/Home/QuickPayment";
import { FireSafetyHome } from "pages/Home/FireSafetyHome";
import MissingReadings from "pages/Admin/MissingReadings";
import UserManagement from "pages/Admin/User/ApproverManagement";
import OtherApplicationRemovalOfConnection from "pages/Consumer/OtherApplications/RemovalOfConnection";
//fire safety
import FireSafetyUserManagement from "pages/FireSafety/FireSafetyUserManagement";
import FireSafetyConsumerDashboard from "pages/Consumer/FireSafety/Dashboard";

import {
  adminDashboardRoute,
  adminUtilityConsumerRoute,
  backupPowerRoute,
  changeOfCategoryRoute,
  demandExtensionRoute,
  demandReductionRoute,
  homeRoute,
  myRequestRoute,
  nameTransferRoute,
  netMeteringRoute,
  permanentRoute,
  premiseAmalgamationRoute,
  premiseRemovalRoute,
  removalOfConnectionRoute,
  shiftingOfServiceRoute,
  temporaryRoute,
  adminPowerApplicationRequestsRoute,
  adminMasterDataRoute,
  consumerComplaintRoute,
  adminComplaintRoute,
  profileRoute,
  adminBillingCycleRoute,
  adminMeterReadingRoute,
  adminBillCalculationsDataRoute,
  consumerPaymentHistoryRoute,
  consumerBillsRoute,
  consumerPaymentRoute,
  consumerDashboardRoute,
  adminPaymentHistoryRoute,
  consumerUtilityConsumersRoute,
  adminReportsRoute,
  adminBillingCalculationReportRoute,
  adminUnpaidBillsRoute,
  adminUserDocumentsRoute,
  adminTechnicalSanctionDocumentsRoute,
  adminDemandEstimateDocumentsRoute,
  adminSecurityDepositRoute,
  adminBillingBackupPowerRoute,
  paymentRoute,
  giftInfo,
  adminHomePageContentRoute,
  adminHomePageDocumentRoute,
  adminTemporaryDisconnectedConsumerRoute,
  adminDispatchedBillRoute,
  otherUtilitiesPermanentRoute,
  otherUtilitiesTemporaryRoute,
  otherUtilitiesNameChangeRoute,
  myOtherRequestRoute,
  adminOtherApplicationRequestsRoute,
  adminPowerAbstractRoute,
  energyCalculator,
  userManagement,
  approverManagement,
  waysToSaveMonet,
  adminActivityLogRoute,
  adminOutstandingReportRoute,
  adminOfflinePaymentRoute,
  adminPowerMissingReadingsRoute,
  adminPowerOutstandingNoticeRoute,
  adminOutstandingInvoiceRoute,
  adminBillingUserBillsRoute,
  otherUtilitiesDemandExtensionRoute,
  otherUtilitiesDemandReductionRoute,
  quickPaymentRoute,
  fireSafetyHomeRoute,
  fireSafetyConsumerDashboardRoute,
  fireSafetyAdminDashboardRoute,
  fireSafetyProfileRoute,
  otherUtilitiesRemovalOfConnectionRoute,
  adminOtherBillingMeterReadingRoute,
  adminBillingDailyMeterReadingsReportRoute,
  fireSafetyUserManagementRoute,
} from "./constants";
import {
  CONSUMER,
  FIRE_SAFETY_CONSUMER,
  FIRE_SAFETY_SUPER_ADMIN,
  SUPER_ADMIN,
  allAdminRoles,
  dcsApplicationsRoles,
  fireSafetyAdminRoles,
  fireSafetyRoles,
  otherUtilitiesRoles,
} from "common/constant";
import { getOptionValue } from "common/enums";

const authProtectedRoutes = [
  // {
  //   path: dashboardRoute,
  //   component: <Dashboard />,
  //   allowRoles: [CONSUMER],
  // },
  {
    path: homeRoute,
    exact: true,
    component: <Navigate to={consumerDashboardRoute} />,
    allowRoles: [CONSUMER],
  },
  {
    path: permanentRoute,
    component: <PermanentConnection />,
    allowRoles: [CONSUMER],
  },
  {
    path: temporaryRoute,
    component: <TemporaryConnection />,
    allowRoles: [CONSUMER],
  },
  {
    path: nameTransferRoute,
    component: <NameTransfer />,
    allowRoles: [CONSUMER],
  },
  {
    path: demandReductionRoute,
    component: <DemandReduction />,
    allowRoles: [CONSUMER],
  },
  {
    path: demandExtensionRoute,
    component: <DemandExtension />,
    allowRoles: [CONSUMER],
  },
  {
    path: premiseAmalgamationRoute,
    component: <PremiseAmalgamation />,
    allowRoles: [CONSUMER],
  },
  {
    path: premiseRemovalRoute,
    component: <PremiseRemoval />,
    allowRoles: [CONSUMER],
  },
  {
    path: shiftingOfServiceRoute,
    component: <ShiftingOfService />,
    allowRoles: [CONSUMER],
  },
  {
    path: changeOfCategoryRoute,
    component: <ChangeOfCategory />,
    allowRoles: [CONSUMER],
  },
  {
    path: netMeteringRoute,
    component: <NetMetering />,
    allowRoles: [CONSUMER],
  },
  {
    path: backupPowerRoute,
    component: <BackupPower />,
    allowRoles: [CONSUMER],
  },
  {
    path: removalOfConnectionRoute,
    component: <RemovalOfConnection />,
    allowRoles: [CONSUMER],
  },
  {
    path: otherUtilitiesPermanentRoute,
    component: <OtherUtilityPermanentConnection />,
    allowRoles: [CONSUMER],
  },
  {
    path: otherUtilitiesTemporaryRoute,
    component: <OtherUtilityTemporaryConnection />,
    allowRoles: [CONSUMER],
  },
  {
    path: otherUtilitiesDemandExtensionRoute,
    component: <OtherUtilityDemandExtension />,
    allowRoles: [CONSUMER],
  },
  {
    path: otherUtilitiesDemandReductionRoute,
    component: <OtherUtilityDemandReduction />,
    allowRoles: [CONSUMER],
  },
  {
    path: otherUtilitiesNameChangeRoute,
    component: <OtherApplicationNameTransfer />,
    allowRoles: [CONSUMER],
  },
  {
    path: otherUtilitiesRemovalOfConnectionRoute,
    component: <OtherApplicationRemovalOfConnection />,
    allowRoles: [CONSUMER],
  },
  {
    path: consumerDashboardRoute,
    component: <ConsumerDashboard />,
    allowRoles: [CONSUMER],
  },
  {
    path: myRequestRoute,
    component: <ApplicationRequestList />,
    allowRoles: [CONSUMER],
  },
  {
    path: myOtherRequestRoute,
    component: <OtherApplicationRequestList />,
    allowRoles: [CONSUMER],
  },
  {
    path: consumerComplaintRoute,
    component: <Complaint />,
    allowRoles: [CONSUMER],
  },

  {
    path: consumerPaymentHistoryRoute,
    component: <PaymentHistory />,
    allowRoles: [CONSUMER],
  },
  {
    path: consumerBillsRoute,
    component: <MyBills />,
    allowRoles: [CONSUMER],
  },
  {
    path: adminDashboardRoute,
    component: <Dashboard />,
    allowRoles: allAdminRoles,
  },
  {
    path: homeRoute,
    exact: true,
    component: <Navigate to={adminDashboardRoute} />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminPowerApplicationRequestsRoute,
    component: <PowerApplicationRequest />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminOtherApplicationRequestsRoute,
    component: <OtherApplicationRequest />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminUtilityConsumerRoute,
    component: <UtilityConsumers />,
    allowRoles: allAdminRoles,
  },
  {
    path: consumerUtilityConsumersRoute,
    component: <UtilityConsumers />,
    allowRoles: [CONSUMER],
  },
  {
    path: profileRoute,
    component: <ProfileDetails />,
    allowRoles: [...allAdminRoles, CONSUMER],
  },
  {
    path: adminReportsRoute,
    component: <Reports />,
    allowRoles: allAdminRoles,
  },
  {
    path: userManagement,
    component: <User />,
    allowRoles: [SUPER_ADMIN],
  },
  {
    path: approverManagement,
    component: <UserManagement />,
    allowRoles: [SUPER_ADMIN],
  },
  {
    path: adminActivityLogRoute,
    component: <ErrorActivities />,
    allowRoles: [SUPER_ADMIN],
  },
  {
    path: adminMasterDataRoute,
    component: <MasterData />,
    allowRoles: [SUPER_ADMIN],
  },

  {
    path: adminComplaintRoute,
    component: <Complaint />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminBillingCycleRoute,
    component: <BillingCycle />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminBillingUserBillsRoute,
    component: <UserBills />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminMeterReadingRoute,
    component: <BillMeterReading />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminOtherBillingMeterReadingRoute,
    component: <OtherUtilityBillMeterReading />,
    allowRoles: [...dcsApplicationsRoles, ...otherUtilitiesRoles, SUPER_ADMIN],
  },
  {
    path: adminBillCalculationsDataRoute,
    component: <ConsumerBillDetails />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminBillingCalculationReportRoute,
    component: <BillCalculationReport />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminBillingDailyMeterReadingsReportRoute,
    component: <DailyMeterReadingReport />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminPowerMissingReadingsRoute,
    component: <MissingReadings />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminUnpaidBillsRoute,
    component: <UnpaidBills />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminPaymentHistoryRoute,
    component: <PaymentHistory />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminOutstandingReportRoute,
    component: <OutstandingReport />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminOutstandingInvoiceRoute,
    component: <OutstandingInvoice />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminSecurityDepositRoute,
    component: <SecurityDeposit />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminBillingBackupPowerRoute,
    component: <BillingBackupPower />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminTemporaryDisconnectedConsumerRoute,
    component: <TemporaryDisconnectedConsumers />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminDispatchedBillRoute,
    component: <DispatchedBill />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminOfflinePaymentRoute,
    component: <OfflinePayment />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminPowerOutstandingNoticeRoute,
    component: <PowerOutstandingNotice />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminPowerAbstractRoute,
    component: <PowerAbstract />,
    allowRoles: allAdminRoles,
  },
  {
    path: adminUserDocumentsRoute,
    component: (
      <Documents
        key={adminUserDocumentsRoute}
        documentEnumType={getOptionValue("documentEnum", "Application")}
        title="User Documents"
      />
    ),
    allowRoles: allAdminRoles,
  },
  {
    path: adminTechnicalSanctionDocumentsRoute,
    component: (
      <Documents
        key={adminTechnicalSanctionDocumentsRoute}
        documentEnumType={getOptionValue("documentEnum", "Technical_Sanction")}
        title="Technical Sanction Documents"
      />
    ),
    allowRoles: allAdminRoles,
  },
  {
    path: adminDemandEstimateDocumentsRoute,
    component: (
      <Documents
        key={adminDemandEstimateDocumentsRoute}
        documentEnumType={getOptionValue("documentEnum", "Demand_Estimate")}
        title="Demand Estimate Documents"
      />
    ),
    allowRoles: allAdminRoles,
  },
  {
    path: adminHomePageContentRoute,
    component: <HomePageContent />,
    allowRoles: [SUPER_ADMIN],
  },
  {
    path: adminHomePageDocumentRoute,
    component: <HomePageDocument />,
    allowRoles: [SUPER_ADMIN],
  },

  //fire safety
  {
    path: fireSafetyHomeRoute,
    exact: true,
    component: <Navigate to={fireSafetyConsumerDashboardRoute} />,
    allowRoles: [FIRE_SAFETY_CONSUMER],
  },
  {
    path: fireSafetyHomeRoute,
    exact: true,
    component: <Navigate to={fireSafetyAdminDashboardRoute} />,
    allowRoles: fireSafetyAdminRoles,
  },
  {
    path: fireSafetyConsumerDashboardRoute,
    component: <FireSafetyConsumerDashboard />,
    allowRoles: [FIRE_SAFETY_CONSUMER],
  },

  {
    path: fireSafetyAdminDashboardRoute,
    component: <FireSafetyConsumerDashboard />,
    allowRoles: fireSafetyAdminRoles,
  },

  {
    path: fireSafetyProfileRoute,
    component: <ProfileDetails />,
    allowRoles: fireSafetyRoles,
  },
  {
    path: fireSafetyUserManagementRoute,
    component: <FireSafetyUserManagement />,
    allowRoles: [FIRE_SAFETY_SUPER_ADMIN],
  },
];

const publicRoutes = [
  {
    path: homeRoute,
    component: <Home />,
  },
  { path: consumerPaymentRoute, component: <PaymentResponse /> },
  { path: paymentRoute, component: <MakePayment /> },
  { path: giftInfo, component: <GiftInfo /> },
  {
    path: energyCalculator,
    component: <EnergyCalculator />,
  },
  { path: waysToSaveMonet, component: <WaysToSaveMoney /> },
  { path: quickPaymentRoute, component: <QuickPayment /> },
  { path: fireSafetyHomeRoute, component: <FireSafetyHome /> },

  {
    path: "*",
    component: (
      <Navigate
        to={
          window.location.href.includes("fire-safety")
            ? fireSafetyHomeRoute
            : homeRoute
        }
      />
    ),
  },
];

export { authProtectedRoutes, publicRoutes };
